export function PageHeader({ title, description, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 sm:gap-6 mb-6 sm:mb-8">
      <div className="min-w-0">
        <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">
          Wineemotion Assistenza
        </div>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-zinc-950 tracking-tighter break-words">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-zinc-500 mt-3 max-w-xl">{description}</p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}
